var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('navigator', 'userAgent') || '';



//////////////////
// WEBPACK FOOTER
// c:/Users/Antanas/Dropbox/am/Projects/typescript/amcharts4dev/node_modules/core-js/internals/engine-user-agent.js
// module id = RjhM
// module chunks = a74a